import {FeaturesEnum, HomeEnum} from 'presentation/constants';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import React from 'react';
import {Navigate} from 'react-router-dom';
import {Notifications} from './pages/Notifications';
import {useContractStatus} from 'presentation/hooks';
import {useAccountInformation} from '../hooks';

export function NotificationsAreaWrapper() {
	const {isValid} = useContractStatus();
	const {isB2BAccess} = useAccountInformation();

	const {isEnabled: isNotificationsFeatureFlagEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_NOTIFICATIONS,
	);
	const shouldRedirectToHome = !isNotificationsFeatureFlagEnabled || !isValid || isB2BAccess;

	if (shouldRedirectToHome) {
		return <Navigate to={HomeEnum.HOME_PAGE} replace />;
	}

	return <Notifications />;
}
